import { usePermissions } from '@/composables/usePermissions';
import Icons from '@/constants/Icons';
import RouteNames from '@/constants/RouteNames';
import AppAction from '@/models/core/AppAction';
import ForemanDeleteModal from '@/views/foreman/ForemanDeleteModal.vue';
import { useModal } from 'vue-final-modal';

type ForemanActionParams = {
  foremanUid: string;
  fullName: string;
};

export const foremanEditAction = (params: Partial<ForemanActionParams>) => {
  const { canUpdateForeman } = usePermissions();

  return new AppAction({
    allowed: canUpdateForeman.value,
    icon: Icons.Core.Edit,
    name: RouteNames.Foreman.Edit,
    route: { name: RouteNames.Foreman.Edit, params },
  });
};

export const foremanDeleteAction = (params: Partial<ForemanActionParams>) => {
  const { canDeleteForeman } = usePermissions();

  return new AppAction({
    allowed: canDeleteForeman.value,
    handler: () => {
      const { open } = useModal({ attrs: params as typeof ForemanDeleteModal.props, component: ForemanDeleteModal });
      open();
    },
    icon: Icons.Core.Delete,
    name: 'ForemanDelete',
  });
};

export const foremanCreateAction = () => {
  const { canCreateForeman } = usePermissions();

  return new AppAction({
    allowed: canCreateForeman.value,
    icon: Icons.Core.Create,
    name: RouteNames.Foreman.Create,
    route: { name: RouteNames.Foreman.Create },
  });
};

export const foremanListAction = () => {
  const { canReadForeman } = usePermissions();

  return new AppAction({
    allowed: canReadForeman.value,
    icon: Icons.Foreman,
    name: RouteNames.Foreman.List,
    route: { name: RouteNames.Foreman.List },
  });
};
